import React from 'react'

export default function MenuPage() {
    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = "/menu.pdf"; // make sure this file exists in your public folder
        link.download = "V The Grand Shoba Menu.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
  return (
    <>
      <div className="menu-img">
        <img src="/images/menuimg.jpg"   alt="menu img" />
      </div>
    <div className="container">
       <div className="container-fluid">
         
       <div className="row m-auto">
            <div className="col-md-12">
               <div className="menu-title mt-4">
                <h3>Menu</h3>
               </div>
               <div className="menu-table">
                <div className="menu-table-title pb-2">
                    <h4><span>V The Grand Shoba </span>Nasta Pani</h4>
                </div>
                <ul className="list-group">
                  <li className="list-group-item">Choley Bhature <span className='float-end text-success'  >&#8377; 150/p</span></li>
                  <li className="list-group-item">Aloo Bedmi Puri <span className='float-end text-success'  >&#8377; 160/p</span></li>
                  <li className="list-group-item">Pav Bhaji (Extra Pav) <span className='float-end text-success'  >&#8377; 99/p</span></li>
                  <li className="list-group-item">Veg Sandwich <span className='float-end text-success'  >&#8377; 95/p</span></li>
                  <li className="list-group-item">Cheese Sandwich <span className='float-end text-success'  >&#8377; 110/p</span></li>
                  <li className="list-group-item">Grilled Sandwich <span className='float-end text-success'  >&#8377; 150/p</span></li>
                  <li className="list-group-item">Butter Toast <span className='float-end text-success'  >&#8377; 150/p</span></li>
                  <li className="list-group-item">Mix Pakora <span className='float-end text-success'  >&#8377; 109/p</span></li>
                  <li className="list-group-item">Paneer Pakora <span className='float-end text-success'  >&#8377; 150/p</span></li>
                  <li className="list-group-item">Paneer Bread Pakora <span className='float-end text-success'  >&#8377; 69/p</span></li>
                </ul>
               </div>

               <div className="menu-table mt-5">
                <div className="menu-table-title pb-2">
                    <h4><span>V The Grand Shoba </span>Parantha</h4>
                </div>
                <ul className="list-group">
                  <li className="list-group-item">Aloo Parantha <span className='float-end text-success'  >&#8377; 110/p</span> </li>
                  <li className="list-group-item">Onion Parantha <span className='float-end text-success'  >&#8377; 109/p</span></li>
                  <li className="list-group-item">Pav Bhaji (Extra Pav) <span className='float-end text-success'  >&#8377; 90/p</span></li>
                  <li className="list-group-item">Aloo Onion Parantha <span className='float-end text-success'  >&#8377; 150/p</span></li>
                  <li className="list-group-item">Gobhi Parantha <span className='float-end text-success'  >&#8377; 155/p</span></li>
                  <li className="list-group-item">Grilled Sandwich <span className='float-end text-success'  >&#8377; 169/p</span></li>
                  <li className="list-group-item">Mix Veg Parantha <span className='float-end text-success'  >&#8377; 150/p</span></li>
                  
                </ul>
               </div>
            </div>
          
          <div className="menu-btn ">
            <button onClick={handleDownload}>View Full Menu</button>
          </div>


        </div>
       </div>
    </div>
    </>
  )
}
